/* src/app/components/admin/admin-download/admin-download.component.scss */
.doc-detail-cell {
  padding: 10px;
  padding-left: 20px;
}
.doc-detail-title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  padding-bottom: 5px;
}
mat-form-field.custom-infix-padding {
  --padding-top: 12px;
  --padding-bottom: 10px;
}
mat-header-cell.mat-mdc-header-cell,
mat-cell.mat-mdc-cell,
mat-footer-cell.mat-mdc-footer-cell {
  padding-right: 0;
}
.mat-column-selectFile {
  flex: 0 0 98px !important;
  padding-right: 0;
  padding-left: 5px;
}
.mat-column-fileType {
  flex: 0 0 280px !important;
}
.mat-column-lifecycle {
  flex: 0 0 100px !important;
}
.include-deleted {
  margin-top: 20px;
  margin-left: 8px;
}
mat-header-cell {
  font-size: 12px;
}
mat-cell {
  font-size: 13px;
}
mat-cell:has(mat-checkbox) {
  justify-content: center;
}
:host-context(.dark-theme) .doc-detail-title {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=admin-download.component.css.map */
